import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Link from 'components/common/Link';
import { Box, Button, Typography, Grid, Hidden, Container } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import { helpDocs } from 'lib/docs';

import Page from 'components/Page/Page';
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";

const useStyles = makeStyles((theme) => ({
	main: {
		display: 'flex',
	},
	content: {
		border: `1px solid ${theme.palette.grey.main}`,
		width: '80%',
		maxWidth: '1000px',
		marginBottom: '50px',
		marginRight: 'auto',
		marginLeft: 'auto',
		padding: '16px 32px',
		borderRadius: '12px',
		backgroundColor: '#FFFFFF',
		'& p': {
			fontSize: '16px',
		},
		'& img': {
			maxWidth: '100%',
			marginTop: '10px',
			marginBottom: '40px',
			maxHeight: '300px',
			border: '0.5px solid grey',
			borderRadius: '6px',
		},
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	directory: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 'max-content',
		paddingLeft: '20px',
		paddingRight: '20px',
		[theme.breakpoints.down('xs')]: {
			display: 'none',
		},
	},
}));

const Guides = (props) => {
	const classes = useStyles();
	const history = useHistory();
	const data = history.location.state;
	const [markdownContent, setMarkdownContent] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		getDoc();
	}, [history.location]);

	// TODO: proper error handling with messages/alerts
	const fetchMarkdown = async (path) => {
		setLoading(true);
		try {
			const response = await fetch(path);
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const text = await response.text();
			setMarkdownContent(text);
		} catch (e) {
			setError(e);
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	const getDoc = () => {
		const path = history.location.pathname;
		const routes = path.split('/');
		const route = routes[routes.length - 1];
		const section = history.location.hash.slice(1);

		helpDocs[section].map((doc) => {
			if (doc.route === route) {
				fetchMarkdown(doc.path);
			}
		});
	};

	const this_route = history.location.pathname.split("/").slice(-1)

	console.log("THIS ROUTE: "+this_route);


	return (
		<Page title={"Help - "+ history.location.hash.slice(1)}>
			<Box className={classes.main}>
				<Box className={classes.directory}>
					<Link
								variant='alternate'
								text="<< Back"
								path={`/app/help/`}
							/>
							<br/>

					{Object.keys(helpDocs).map((section) => (
						<>
							<Typography variant="h2" color="primary">Other articles for this topic:</Typography>

							{_.map(helpDocs[section], doc => {
								console.log(doc.route)

								let mybgcolor = (doc.route == this_route) ? 'rgb(0,79,113)' : 'white';

								 return <>
									 		<Card variant="outlined"  style={{'backgroundColor': mybgcolor, 'padding': '5px'}}>
												<CardContent style={{'padding': '10px'}}>
													<Link
														variant='alternate'
														text={doc.name}
														path={`/app/help/guides/${doc.route}#operatorGuides`}
													/>
												</CardContent>
											</Card>
										 </>
									 })
									 }

								 </>
							))
							}
								</Box>

						<Box className={classes.content}>
						<Box >
							<ReactMarkdown>{markdownContent}</ReactMarkdown>
					</Box>
				</Box>
			</Box>
		</Page>
	);
};

export default Guides;
